import { formatDate, IconLoader, IconPower, PermissionEnum } from '@ui/src';
import { Device } from '../../types';

import cn from '../styles.module.css';

const formatDevicesList = (
  list: Device[],
  activePermissions: PermissionEnum[],
  onEndSessions: (id: string) => void,
  endSessionInProgress?: boolean,
  selectedDeviceId?: string,
): Device[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const render: Record<string, React.JSX.Element> = {};
    render.createdAt = (
      <div>{result.createdAt ? formatDate(result.createdAt, true) : '-'}</div>
    );
    render.ip = (
      <div className={cn.ipRow}>
        <div className={cn.ipRowValue}>{result.ip}</div>
        {activePermissions?.includes(
          PermissionEnum.CUSTOMERS_SESSIONS_DELETE_ACTION,
        ) && (
          <button
            type="button"
            className={cn.endSessionButton}
            aria-label="End all session button"
            disabled={Boolean(
              endSessionInProgress && selectedDeviceId === result.id,
            )}
            onClick={() => onEndSessions(result.id)}
          >
            {endSessionInProgress && selectedDeviceId === result.id ? (
              <IconLoader width={16} height={16} />
            ) : (
              <IconPower />
            )}
          </button>
        )}
      </div>
    );

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatDevicesList;
